/** Common Error Codes */
export default {
  badRequest: 'E011001',
  missingArguments: 'E011002',
  invalidRequest: 'E011003',
  invalidArguments: 'E011004',
  wrongOTPCode: 'E061102',
  tooManyOTPAttempts: 'E061103',
  enchantedLinkPending: 'E062503',
  userNotFound: 'E062108',
};
